import Icon from './Icon';
import {IconProps} from './type';
import {Path} from 'react-native-svg';
import React from 'react';

const Directions: React.FC<IconProps> = props => {
  return (
    <Icon width={24} height={24} viewBox="0 0 24 24" {...props}>
      <Path fill="none" d="M0 0h24v24H0V0z" />
      <Path d="M22.43 10.59l-9.01-9.01 9 9-9 9zM8 11v4h2v-3h4v2.5l3.5-3.5L14 7.5V10H9c-.55 0-1 .45-1 1z" />
    </Icon>
  );
};

export default React.memo(Directions);
